<h2 mat-dialog-title>
    <span style="font-weight: 600;">{{'config_default_image.title' | translate}}</span>
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
</h2>
<h6>{{'config_default_image.sub_title' | translate}}</h6>

<div class="header-table">
    <div class="w-50 font-bold px-2">{{'config_default_image.signature_component' | translate}}</div>
    <div class="w-25 text-center  px-2">
        <div class="font-bold">{{'header.default' | translate}}</div>
        <em style="font-size: 13px;">({{'config_default_image.default_info' | translate}})</em>
    </div>
    <div class="w-25 text-center px-2">
        <div class="font-bold">{{'headertable.required' | translate}}</div>
        <em style="font-size: 13px;">({{'config_default_image.required_info' | translate}})</em>
    </div>
</div>
<table class="w-100 mb-3"> 
    <tbody>
        <tr *ngFor="let item of signConfig">
            <td class="w-50 pl-2 py-1">
                <div>{{getName(item.signatureComponent)}}</div>
                <em style="font-size: 13px;" *ngIf="item.signatureComponent == 'dateTime'">({{'config_default_image.date_description' | translate}})</em>
                <em style="font-size: 13px;" *ngIf="item.signatureComponent == 'phone'">({{'config_default_image.only_otp' | translate}})</em>
            </td>
            <td class="w-25 text-center py-1"><mat-checkbox [(ngModel)]="item.isDefault" (ngModelChange)="changeValue(item)"></mat-checkbox></td>
            <td class="w-25 text-center py-1"><mat-checkbox [(ngModel)]="item.isRequire" (ngModelChange)="isChange = true" [disabled]="!item.isDefault"></mat-checkbox></td>
        </tr>
    </tbody>
</table>

<div class="justify-content-center" mat-dialog-actions>
    <button mat-stroked-button (click)="cancel()" color="primary" cdkFocusInitial class="mr-3" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "button.cancel" | translate }}
    </button>
    <button mat-raised-button type="submit" [disabled]="!isChange" (click)="save()"  color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        {{ "digital-certificate-default.dialog_add.done" | translate }}
    </button>
</div>